import { render, staticRenderFns } from "./Mentionslegales.vue?vue&type=template&id=3411f6bf&"
import script from "./Mentionslegales.vue?vue&type=script&lang=js&"
export * from "./Mentionslegales.vue?vue&type=script&lang=js&"
import style0 from "./Mentionslegales.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports